// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-harsha-a-jadhav",
    "name": "Mrs. Harsha A. Jadhav",
    "designation": "Assistant Professor and HOD",
    "role": "Assistant Professor and HOD",
    "qualification": "M.Tech.",
    "qualifications": "M.Tech.",
    "image": "/FacultyCImages/harsha_jadhav_CIVIL.jpeg",
    "email": "haj@klsvdit.edu.in",
    "phone": "+91 98866 67910",
    "showPhone": true,
    "experience": "14.5 years",
    "description": "Prof. Harsha Jadhav completed B.E Civil from BEC Bagalkot and M.Tech from NITK Surathkal. From past 14 years working at KLS VDIT.",
    "bio": "Prof. Harsha Jadhav completed B.E Civil from BEC Bagalkot and M.Tech from NITK Surathkal. From past 14 years working at KLS VDIT.",
    "specializations": [
      "Pavement Design",
      "Traffic planning",
      "Town planning",
      "Software based traffic analysis"
    ],
    "areas": [
      "Pavement Design",
      "Traffic planning",
      "Town planning",
      "Software based traffic analysis"
    ],
    "courses": [
      "Highway Engineering",
      "Airport Engineering",
      "Pavement Materials",
      "Railway Engineering"
    ],
    "publications": 0,
    "projects": 0,
    "linkedin": "https://www.linkedin.com/in/harsha-jadhav-721909413",
    "irins": "https://klsvdit.irins.org/profile/248691",
    "recognition": [
      "information to be updated"
    ]
  },
  "members": [
    {
      "id": "f-rakesh-patil",
      "name": "Mr. Rakesh Patil",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/rakesh_patil_CIVIL.jpeg",
      "email": "rjp@klsvdit.edu.in",
      "phone": "+91 81478 61076",
      "showPhone": false,
      "experience": "11 years",
      "description": "Mr. Rakesh Patil heads the Engineering Geology Laboratory and specializes in Engineering Geology, GIS, and QGIS applications. He is actively involved in geological mapping, watershed management, remote sensing, geospatial analysis, and environmental studies. He guides students in practical training, research activities, and consultancy projects related to sustainable development.",
      "bio": "Mr. Rakesh Patil heads the Engineering Geology Laboratory and specializes in Engineering Geology, GIS, and QGIS applications. He is actively involved in geological mapping, watershed management, remote sensing, geospatial analysis, and environmental studies. He guides students in practical training, research activities, and consultancy projects related to sustainable development.",
      "specializations": [
        "Geology",
        "Remote Sensing and Geographic Information Systems (GIS)",
        "Hydrology",
        "Advanced Surveying"
      ],
      "areas": [
        "Geology",
        "Remote Sensing and Geographic Information Systems (GIS)",
        "Hydrology",
        "Advanced Surveying"
      ],
      "courses": [
        "Engineering Geology",
        "Remote Sensing And Geographic Information Systems (GIS)",
        "Watershed Management",
        "Environment Engineering"
      ],
      "publications": 4,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/rakesh-patil-63aa86129",
      "irins": "https://klsvdit.irins.org/profile/248743",
      "recognition": [
        "Member of Professional bodies Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)"
      ]
    },
    {
      "id": "f-ashik-bellary",
      "name": "Dr. Ashik Bellary",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_ashik_ballary_CIVIL.jpeg",
      "email": "acb@klsvdit.edu.in",
      "phone": "+91 97382 55856",
      "showPhone": false,
      "experience": "10 years",
      "description": "Dr. Ashik C. Bellary is Associate Professor in Civil Engineering at KLS VDIT, Haliyal. He is a Justo Gold Medalist in M.E. Highway Engineering, holds a PhD from NITK Surathkal, specializes in concrete pavement design, sustainable materials, and mining waste utilization, with 10 years of experience, and has published SCI and Scopus journal articles.",
      "bio": "Dr. Ashik C. Bellary is Associate Professor in Civil Engineering at KLS VDIT, Haliyal. He is a Justo Gold Medalist in M.E. Highway Engineering, holds a PhD from NITK Surathkal, specializes in concrete pavement design, sustainable materials, and mining waste utilization, with 10 years of experience, and has published SCI and Scopus journal articles.",
      "specializations": [
        "Pavement Materials",
        "Pavement Analysis and Design",
        "Traffic Engineering",
        "Application of Artificial Intelligence (AI) and Machine Learning (ML) in Civil Engineering"
      ],
      "areas": [
        "Pavement Materials",
        "Pavement Analysis and Design",
        "Traffic Engineering",
        "Application of Artificial Intelligence (AI) and Machine Learning (ML) in Civil Engineering"
      ],
      "courses": [
        "Design And Construction Of Highway Pavements",
        "Geotechnical Engineering",
        "Concrete Technology",
        "Road Safety Engineering"
      ],
      "publications": 7,
      "projects": 0,
      "linkedin": "https://linkedin.com/in/ashik-bellary-73191160",
      "irins": "https://klsvdit.irins.org/profile/259179",
      "recognition": [
        "\"Ph.D Research Fellowship\", National Institute of Technology Karnataka, Surathkal, India, 2017",
        "Prof. C E G Justo Gold Medal\", in 53rd Bangalore University convocation for scoring highest marks in Master of Engineering (M.E).- Highway Engineering",
        "\"Post Graduate Scholarship (GATE)\", Ministry of Human Resource and Development, Government of India, 2014-2016",
        "\"Best Project of the Year - 2017 award\", (For Guiding the Project) in Karnataka State Council for Science and Technology (KSCST)'s Student Project Programme (SPP) exhibition held at Nitte Mahalinga Adyanthaya Memorial (NMAM) Institute of Technology, Nitte",
        "\"Chairperson\", International Conference on Sustainable Infrastructure: Innovations, Opportunities and Challenges-2023 (SIIOC-2023) organised by National Institute of Technology Karnataka (NITK) Surathkal",
        "Reviewer for International Journal of Pavement Engineering, Discover Materials and Sustainable Innovation Infrastructure Springer Publishers",
        "Successfully completed \"Indo Universal Collaboration for Engineering Education (IUCEE) International Engineering Educator Certification Program\" Spring",
        "Successfully completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certification Program on \"Machine Learning\" a six-months course at IISc (Indian Institute of Science) Bengaluru from July 2024 - December",
        "Invited as \"Guest of Honour\" for Engineers Day Celebration 2024 at Karwar organised by Association of Consulting Civil Engineers Karwar",
        "\"Member of Advisory committee\" Civil Technology (CIVITECH) Summit 2025, organised by Association of Consulting Civil Engineers, Dharwad Local Centre on 1st and 2nd March 2025",
        "Received \"Vocational Excellence Award\" on 5th September 2025 from Association of Consulting Civil Engineers (ACCE) Dharwad Local Centre (DLC)",
        "Life time member of Indian Roads Congress (IRC)",
        "Life time member of Indian Geotechnical Society (IGS)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Institution of Engineers India (IEI)",
        "Life time member of Indian Concrete Institute (ICI)",
        "Certified Chartered Civil Engineer"
      ]
    },
    {
      "id": "f-siddalingayya-g-hiremath",
      "name": "Mrs. Siddalingayya G Hiremath",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/s_g_hiremath_CIVIL.jpeg",
      "email": "sghalnhiremath@gmail.com",
      "phone": "+91 94486 33855",
      "showPhone": false,
      "experience": "24 years",
      "description": "Mr. Siddalingayya Gadigeyya Hiremath is an Assistant Professor in the Department of Civil Engineering at KLS VDIT. He completed his graduation from Karnataka University, Dharwad, in 1999 and earned his postgraduate degree from VTU in 2003. His academic interests and expertise focus on Environmental Engineering and related areas.",
      "bio": "Mr. Siddalingayya Gadigeyya Hiremath is an Assistant Professor in the Department of Civil Engineering at KLS VDIT. He completed his graduation from Karnataka University, Dharwad, in 1999 and earned his postgraduate degree from VTU in 2003. His academic interests and expertise focus on Environmental Engineering and related areas.",
      "specializations": [
        "Environmental Engineering"
      ],
      "areas": [
        "Environmental Engineering"
      ],
      "courses": [
        "Engineering Mechanics",
        "Water Supply And Waste Water Engineering",
        "Solid Waste Management"
      ],
      "publications": 1,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/s-g-hiremath-347b00413/",
      "irins": "https://klsvdit.irins.org/profile/248699",
      "recognition": [
        "Member of Professional Bodies Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)"
      ]
    },
    {
      "id": "f-vijaylaxmi-b-vyakaranahal",
      "name": "Mrs. Vijaylaxmi B Vyakaranahal",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/vijaylakshmi_vyakarnal_CIVIL.jpeg",
      "email": "vbv@klsvdit.edu.in",
      "phone": "+91 94803 69153",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mrs. Vijaylaxmi B. V. completed her B.E. in Civil Engineering from S.M.C.E.T., Dharwad, and M.Tech. in Structural Engineering from B.V.B.C.E.T., Hubballi. She is currently serving as an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology Haliyal. With over a decade of teaching experience, she has been actively involved in teaching. She also serves as the Department Alumni Coordinator and Department Internal Assessment (IA) Coordinator,actively promoting alumni engagement and continuous improvement in teaching-learning processes.",
      "bio": "Mrs. Vijaylaxmi B. V. completed her B.E. in Civil Engineering from S.M.C.E.T., Dharwad, and M.Tech. in Structural Engineering from B.V.B.C.E.T., Hubballi. She is currently serving as an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology Haliyal. With over a decade of teaching experience, she has been actively involved in teaching. She also serves as the Department Alumni Coordinator and Department Internal Assessment (IA) Coordinator,actively promoting alumni engagement and continuous improvement in teaching-learning processes.",
      "specializations": [
        "Concrete Technology",
        "Alternative Building Materials",
        "Masonry Structures",
        "Sustainable Construction Materials"
      ],
      "areas": [
        "Concrete Technology",
        "Alternative Building Materials",
        "Masonry Structures",
        "Sustainable Construction Materials"
      ],
      "courses": [
        "Building Materials And Construction",
        "Concrete Technology",
        "Construction Management",
        "Alternative Building Materials"
      ],
      "publications": 5,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/vijaylaxmi-v-1b51a0242",
      "irins": "https://klsvdit.irins.org/profile/248733",
      "recognition": [
        "Member of Professional Bodies A member of Indian Society for Technical Education (ISTE)",
        "Institution of Engineers India (IEI)",
        "All India Council for Technical Education (AICTE)-Quality Improvement Programme (QIP) Postgraduate (PG) Certification Course on Cyber Physical System at Indian Institute of Information Technology (IIIT), Dharwad"
      ]
    },
    {
      "id": "f-seema-basarikatti",
      "name": "Mrs. Seema Basarikatti",
      "designation": "Assistant professor",
      "role": "Assistant professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/seema_basarikatti_CIVIL.jpeg",
      "email": "srb@klsvdit.edu.in",
      "phone": "+91 78992 30208",
      "showPhone": false,
      "experience": "14 years",
      "description": "Ms. Seema Basarikatti is pursuing her Ph.D at SDMCET Dharwad under VTU. Her research interests are water resource Engineering, Hydrology & Irrigation.",
      "bio": "Ms. Seema Basarikatti is pursuing her Ph.D at SDMCET Dharwad under VTU. Her research interests are water resource Engineering, Hydrology & Irrigation.",
      "specializations": [
        "Water Resource Engineering",
        "Environmental engineering",
        "Hydrology and Hydraulics & Irrigation Engineering"
      ],
      "areas": [
        "Water Resource Engineering",
        "Environmental engineering",
        "Hydrology and Hydraulics & Irrigation Engineering"
      ],
      "courses": [
        "Fluid Mechanics",
        "Hydrology And Irrigation Engineering",
        "Engineering Survey",
        "Solid Waste Management"
      ],
      "publications": 2,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/seema-basarikatti-152466250?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/248741",
      "recognition": [
        "Member of Indian National Chapter of the International Association of Hydrogeologists (INC-IAH)"
      ]
    },
    {
      "id": "f-laxmi-g-hattiholi",
      "name": "Mrs. Laxmi G Hattiholi",
      "designation": "Assistant Professor and IQAC coordinator",
      "role": "Assistant Professor and IQAC coordinator",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/laxmi_hattihole_CIVIL.jpeg",
      "email": "lgh@klsvdit.edu.in",
      "phone": "+91 95912 46989",
      "showPhone": false,
      "experience": "14 years",
      "description": "Prof. Laxmi Hattiholi is an Assistant Professor in the Department of Civil Engineering at KLS VDIT, Haliyal, and serves as the IQAC Coordinator. She is pursuing a Ph.D. with a focus on sustainable construction materials. Passionate about continuous learning and innovation, she actively contributes to teaching, institutional development, and social causes, with a commitment to creating a positive impact on society.",
      "bio": "Prof. Laxmi Hattiholi is an Assistant Professor in the Department of Civil Engineering at KLS VDIT, Haliyal, and serves as the IQAC Coordinator. She is pursuing a Ph.D. with a focus on sustainable construction materials. Passionate about continuous learning and innovation, she actively contributes to teaching, institutional development, and social causes, with a commitment to creating a positive impact on society.",
      "specializations": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Sustainable Construction Materials",
        "Soil Structure Interaction"
      ],
      "areas": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Sustainable Construction Materials",
        "Soil Structure Interaction"
      ],
      "courses": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Design Of Reinforced Concrete (RC) Structural Elements",
        "Prestressed Concrete"
      ],
      "publications": 4,
      "projects": 4,
      "linkedin": "https://in.linkedin.com/in/laxmi-hattiholi-924a882a",
      "irins": "https://klsvdit.irins.org/profile/259179",
      "recognition": [
        "Member of Professional bodies Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Received Research grants from Visvesvaraya Technological University (VTU), Karnataka State Council for Science and Technology (KSCST)",
        "Received Indian Green Building Council (IGBC) accredited Faculty award",
        "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) certification course in Cyber security at Indian Institute of Information Technology (IIIT) dharwad"
      ]
    },
    {
      "id": "f-harshvardhan-v-s",
      "name": "Mr. Harshvardhan V.S.",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "image": "/FacultyCImages/harshvardhan_v_s_CIVIL.jpeg",
      "email": "hvs@klsvdit.edu.in",
      "phone": "+91 98805 71527",
      "showPhone": false,
      "experience": "10 years",
      "description": "Prof. Harshavardhan V.S. is an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology (VDIT) in Haliyal, Karnataka.",
      "bio": "Prof. Harshavardhan V.S. is an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology (VDIT) in Haliyal, Karnataka.",
      "specializations": [
        "Structural Engineering",
        "Geotechnical Engineering"
      ],
      "areas": [
        "Structural Engineering",
        "Geotechnical Engineering"
      ],
      "courses": [
        "Geotechnical Engineering",
        "Strength Of Material",
        "Design Of Bridges",
        "Analysis Of Structures"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/harshavardhan-v-s-43b589413/",
      "irins": "https://klsvdit.irins.org/profile/248737",
      "recognition": []
    }
  ]
};

export default facultyData;
